// removed by extract-text-webpack-plugin
module.exports = {"externalLink":"styles__externalLink___18ve6"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/CompanyView/styles.scss
// module id = ./resources/assets/js/components/CompanyView/styles.scss
// module chunks = 0